import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const TermsOfServicePage = () => (
  <LegalPageLayout title="Terms of Service" lastUpdated="July 11, 2026">
    <p>
      Welcome to <strong>UBSAAPP</strong> (&quot;UBSAAPP&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;).
      These Terms of Service (&quot;Terms&quot;) govern your access to and use of our website, mobile
      application, and related services for discovering and booking stays, meeting rooms, and
      related hospitality services in India and elsewhere.
    </p>
    <p>
      By creating an account, searching, listing a property, or completing a booking, you agree
      to these Terms. If you do not agree, please do not use UBSAAPP.
    </p>

    <h2>1. About UBSAAPP</h2>
    <p>
      UBSAAPP is a technology platform operated by <strong>AtoZ Auto</strong> that connects guests
      with hosts and venue providers. We facilitate discovery, enquiries, bookings, payments, and
      communication but are not the owner or operator of listed properties unless expressly stated.
    </p>

    <h2>2. Eligibility</h2>
    <p>You must be at least 18 years old and capable of entering a binding contract under Indian law to use our services. By using UBSAAPP, you represent that the information you provide is accurate and current.</p>

    <h2>3. Accounts &amp; Authentication</h2>
    <ul>
      <li>You may sign in using email OTP, Google, or other methods we support.</li>
      <li>You are responsible for safeguarding your account and all activity under it.</li>
      <li>Notify us promptly at <a href="mailto:info.ubsaaap@atozasindia.in">info.ubsaaap@atozasindia.in</a> if you suspect unauthorised access.</li>
      <li>We may suspend or terminate accounts that violate these Terms or applicable law.</li>
    </ul>

    <h2>4. Stays &amp; Accommodation Bookings</h2>
    <ul>
      <li>Search results may include host-listed properties and third-party inventory.</li>
      <li>Prices, availability, house rules, and cancellation terms are set by hosts or suppliers and shown before you confirm.</li>
      <li>A booking is confirmed only after payment (where required) and host or system acceptance as shown in your confirmation.</li>
      <li>You agree to respect property rules, local laws, and reasonable check-in/check-out times.</li>
    </ul>

    <h2>5. Meeting Rooms &amp; Workspace Bookings</h2>
    <p>
      Meeting room listings may include private company spaces and public venues. Access, capacity,
      equipment, and cancellation rules are displayed at booking time. You are responsible for
      lawful use of booked spaces and for any damage caused by you or your attendees.
    </p>

    <h2>6. Host &amp; Listing Obligations</h2>
    <p>If you list a property or meeting room on UBSAAPP, you agree to:</p>
    <ul>
      <li>Provide accurate descriptions, photos, pricing, availability, and amenities.</li>
      <li>Maintain valid licences or permissions required under local law.</li>
      <li>Honour confirmed bookings and respond to guest enquiries in a reasonable time.</li>
      <li>Comply with tax, safety, and consumer protection obligations applicable to you.</li>
    </ul>

    <h2>7. Payments, Fees &amp; Refunds</h2>
    <ul>
      <li>Payments are processed through secure third-party payment providers.</li>
      <li>Service fees, taxes, cleaning charges, or deposits may apply and will be shown at checkout.</li>
      <li>Refunds follow the cancellation policy displayed for each listing and our refund processing timelines.</li>
      <li>Chargebacks or fraudulent payment activity may result in account suspension.</li>
    </ul>

    <h2>8. Reviews &amp; User Content</h2>
    <p>
      You may submit reviews, messages, photos, and other content. You grant UBSAAPP a non-exclusive,
      worldwide licence to use, display, and distribute that content in connection with the platform.
      Do not post content that is false, defamatory, infringing, or offensive.
    </p>

    <h2>9. Prohibited Conduct</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the platform for unlawful, fraudulent, or harmful purposes.</li>
      <li>Scrape, reverse engineer, or overload our systems without permission.</li>
      <li>Harass hosts, guests, or UBSAAPP staff.</li>
      <li>Circumvent fees by transacting off-platform after initial contact through UBSAAPP.</li>
      <li>List properties you do not have authority to offer.</li>
    </ul>

    <h2>10. Third-Party Services &amp; Links</h2>
    <p>
      Some listings or map data may come from external partners. We are not responsible for
      third-party websites, APIs, or services linked from UBSAAPP. Your use of those services
      is subject to their own terms.
    </p>

    <h2>11. Disclaimers</h2>
    <p>
      UBSAAPP is provided on an &quot;as is&quot; and &quot;as available&quot; basis. We do not guarantee
      uninterrupted access, error-free operation, or that every listing will meet your expectations.
      Hosts and guests enter into a direct relationship regarding the stay or venue; UBSAAPP is a
      facilitator unless we explicitly act as merchant of record for a transaction.
    </p>

    <h2>12. Limitation of Liability</h2>
    <p>
      To the maximum extent permitted by law, AtoZ Auto and UBSAAPP shall not be liable for indirect,
      incidental, special, or consequential damages arising from your use of the platform, a booking,
      or interactions with other users. Our aggregate liability for any claim relating to the services
      shall not exceed the fees paid by you to UBSAAPP for the booking giving rise to the claim in
      the preceding three (3) months.
    </p>

    <h2>13. Indemnity</h2>
    <p>
      You agree to indemnify and hold harmless UBSAAPP, AtoZ Auto, and their officers and employees
      from claims arising out of your breach of these Terms, your listings, your bookings, or your
      violation of any law or third-party rights.
    </p>

    <h2>14. Governing Law &amp; Disputes</h2>
    <p>
      These Terms are governed by the laws of India. Courts at New Delhi shall have exclusive
      jurisdiction, subject to applicable consumer protection laws that may provide you additional
      rights in your place of residence.
    </p>

    <h2>15. Changes to These Terms</h2>
    <p>
      We may update these Terms from time to time. Material changes will be posted on this page with
      an updated date. Continued use after changes constitutes acceptance of the revised Terms.
    </p>

    <h2>16. Contact Us</h2>
    <p>
      <strong>AtoZ Auto</strong><br />
      F-18, PH VI AYA NAGAR EXTN., New Delhi, Delhi, India – 110047<br />
      Email: <a href="mailto:info.ubsaaap@atozasindia.in">info.ubsaaap@atozasindia.in</a>
    </p>
  </LegalPageLayout>
);

export default TermsOfServicePage;
